import type { OrderContextActionsProps } from './OrderContextActionsWidget.js'
import { TooltipTrigger } from '../../../../Provider/TooltipManager.js'
import type React from 'react'

interface MenuButtonProps {
  label: string
  labelClassName?: string
  onClick: () => void
  icon?: React.ReactNode
  tooltip?: string
  props: OrderContextActionsProps
  disabled: boolean
  disabledTooltip?: string
  testId?: string
  marker?: React.ReactNode
}

export const MenuButton: React.FC<MenuButtonProps> = (props: MenuButtonProps) => {
  return (
    <TooltipTrigger tooltip={props.tooltip} disabledTooltip={props.disabledTooltip} disabled={props.disabled}>
      <li className="w-full">
        <button
          data-testid={props.testId}
          onClick={props.onClick}
          disabled={props.disabled}
          className={`sm:max-md:border sm:max-md:py-2 sm:max-md:rounded sm:max-md:text-xl flex items-center sm:max-md:justify-center
          whitespace-nowrap px-2 py-1 w-full text-left ${props.disabled ? 'text-gray-400' : ''} ${props.labelClassName}`}
        >
          {props.icon && <span className="mr-2">{props.icon}</span>}
          {props.label}
          {props.marker && <span className="ml-2">{props.marker}</span>}
        </button>
      </li>
    </TooltipTrigger>
  )
}
